import { useEffect, useState } from 'react';

/**
 * Devolve o valor com atraso, para não disparar uma consulta por tecla digitada.
 *
 * ⚠️ **O valor adiado é para a REDE, não para a tela.** O `<input>` continua
 * controlado pelo estado imediato — segurar o texto digitado atrás do atraso
 * deixaria o campo com aparência de travado.
 */
export function useDebounce<T>(valor: T, ms = 300): T {
  const [adiado, setAdiado] = useState(valor);

  useEffect(() => {
    const id = setTimeout(() => setAdiado(valor), ms);
    return () => clearTimeout(id);
  }, [valor, ms]);

  return adiado;
}
